
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i4xCZ", function(module, exports) {
"use strict";

var $5Okwt = parcelRequire("5Okwt");

var $5zwnU = parcelRequire("5zwnU");
var $d282af7bdeb9fd2c$var$DatePrototype = Date.prototype;
var $d282af7bdeb9fd2c$var$INVALID_DATE = "Invalid Date";
var $d282af7bdeb9fd2c$var$TO_STRING = "toString";
var $d282af7bdeb9fd2c$var$nativeDateToString = $5Okwt($d282af7bdeb9fd2c$var$DatePrototype[$d282af7bdeb9fd2c$var$TO_STRING]);
var $d282af7bdeb9fd2c$var$thisTimeValue = $5Okwt($d282af7bdeb9fd2c$var$DatePrototype.getTime);
// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) !== $d282af7bdeb9fd2c$var$INVALID_DATE) $5zwnU($d282af7bdeb9fd2c$var$DatePrototype, $d282af7bdeb9fd2c$var$TO_STRING, function toString() {
    var value = $d282af7bdeb9fd2c$var$thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? $d282af7bdeb9fd2c$var$nativeDateToString(this) : $d282af7bdeb9fd2c$var$INVALID_DATE;
});

});

"use strict";
parcelRequire("4CEV9");


//# sourceMappingURL=index.7ed20952.js.map
